module.exports = __webpack_public_path__ + "img/hero-8-bg.82066c99.jpg";